import CryptoJS from 'crypto-js';

export const generateChecksum = (body) => {
    const finalString = Object.keys(body)
        .filter(key => key !== 'checksum')
        .map(key => `${key}=${body[key]}`)
        .join('&');
    return CryptoJS.HmacSHA256(finalString, process.env.REACT_APP_SECRET_WEB_KEY).toString();
}

export const generateChecksumJson = (body) => {
    const sortedKeys = Object.keys(body).sort();
    const sortedData = sortedKeys.reduce((acc, key) => {
      if (key !== 'checksum') {
        acc.push(`${key}=${body[key]}`);
      }
      return acc;
    }, []).join('&')
    return CryptoJS.HmacSHA256(sortedData, process.env.REACT_APP_SECRET_WEB_KEY).toString();
};